// extracted by mini-css-extract-plugin
export default {"container":"index-module--container--3c029","tabs":"index-module--tabs--b33ba"};